import { MenuItem, TextField } from '@mui/material'
import { useField } from 'formik'
import React from 'react'
import { translate } from 'utils/propKeysTranslations'

const Select = ({ options, name }) => {
  const [field, meta] = useField(name)
  const isInvalid = meta.touched && meta.error
  return (
    <div>
      <TextField
        size='small'
        label={translate(name)}
        {...field}
        error={!!meta.error}
        select
        fullWidth
        variant='filled'
        sx={{ minWidth: '125px' }}
      >
        {(options || []).map(({ name }) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </TextField>
      {isInvalid && <div className='text-red-500 text-sm'>{meta.error}</div>}
    </div>
  )
}

export default Select
